export function Instagram() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_861_786)">
        <path
          d="M12.75 0.495117H4.25C2.17893 0.495117 0.5 2.17405 0.5 4.24512V12.7451C0.5 14.8162 2.17893 16.4951 4.25 16.4951H12.75C14.8211 16.4951 16.5 14.8162 16.5 12.7451V4.24512C16.5 2.17405 14.8211 0.495117 12.75 0.495117Z"
          fill="url(#paint0_radial_861_786)"
        />
        <path
          d="M12.75 0.495117H4.25C2.17893 0.495117 0.5 2.17405 0.5 4.24512V12.7451C0.5 14.8162 2.17893 16.4951 4.25 16.4951H12.75C14.8211 16.4951 16.5 14.8162 16.5 12.7451V4.24512C16.5 2.17405 14.8211 0.495117 12.75 0.495117Z"
          fill="url(#paint1_radial_861_786)"
        />
        <path
          d="M8.50056 2.24512C6.80319 2.24512 6.59013 2.25255 5.9235 2.28287C5.25813 2.31337 4.80394 2.41868 4.40656 2.57324C3.99544 2.73287 3.64675 2.94643 3.29938 3.29393C2.95169 3.64137 2.73813 3.99005 2.578 4.40099C2.423 4.79849 2.31756 5.25287 2.28762 5.91793C2.25781 6.58462 2.25 6.79774 2.25 8.49518C2.25 10.1926 2.2575 10.405 2.28775 11.0716C2.31838 11.737 2.42369 12.1912 2.57812 12.5886C2.73787 12.9997 2.95144 13.3484 3.29894 13.6957C3.64625 14.0434 3.99494 14.2575 4.40575 14.4171C4.80344 14.5717 5.25769 14.677 5.92294 14.7075C6.58962 14.7378 6.8025 14.7452 8.49981 14.7452C10.1974 14.7452 10.4097 14.7378 11.0764 14.7075C11.7417 14.677 12.1964 14.5717 12.5941 14.4171C13.0051 14.2575 13.3532 14.0434 13.7005 13.6957C14.0482 13.3484 14.2617 12.9997 14.4219 12.5887C14.5755 12.1912 14.681 11.7369 14.7122 11.0717C14.7422 10.4051 14.75 10.1926 14.75 8.49518C14.75 6.79774 14.7422 6.58474 14.7122 5.91805C14.681 5.25268 14.5755 4.79855 14.4219 4.40118C14.2617 3.99005 14.0482 3.64137 13.7005 3.29393C13.3529 2.9463 13.0052 2.73274 12.5938 2.5733C12.1953 2.41868 11.7409 2.3133 11.0755 2.28287C10.4088 2.25255 10.1966 2.24512 8.49862 2.24512H8.50056ZM7.93988 3.37143C8.10631 3.37118 8.292 3.37143 8.50056 3.37143C10.1694 3.37143 10.3671 3.37743 11.0261 3.40737C11.6355 3.43524 11.9663 3.53705 12.1866 3.62262C12.4783 3.73587 12.6862 3.8713 12.9048 4.09012C13.1236 4.30887 13.2589 4.51718 13.3725 4.80887C13.4581 5.02887 13.56 5.35962 13.5878 5.96899C13.6177 6.62787 13.6242 6.82574 13.6242 8.49374C13.6242 10.1617 13.6177 10.3597 13.5878 11.0185C13.5599 11.6279 13.4581 11.9586 13.3725 12.1787C13.2593 12.4704 13.1236 12.6781 12.9048 12.8967C12.6861 13.1154 12.4784 13.2508 12.1866 13.3641C11.9665 13.4501 11.6355 13.5516 11.0261 13.5795C10.3673 13.6094 10.1694 13.6159 8.50056 13.6159C6.83169 13.6159 6.63387 13.6094 5.97506 13.5795C5.36569 13.5514 5.03494 13.4496 4.81444 13.364C4.52281 13.2507 4.31444 13.1153 4.09569 12.8966C3.87694 12.6778 3.74156 12.47 3.628 12.1782C3.54244 11.9581 3.4405 11.6274 3.41275 11.018C3.38281 10.3591 3.37681 10.1612 3.37681 8.49218C3.37681 6.82312 3.38281 6.6263 3.41275 5.96743C3.44062 5.35805 3.54244 5.0273 3.628 4.80699C3.74131 4.5153 3.87694 4.30699 4.09575 4.08824C4.31456 3.86949 4.52281 3.73405 4.8145 3.62055C5.03481 3.53462 5.36569 3.43305 5.97506 3.40505C6.55162 3.37899 6.77506 3.37118 7.93988 3.36987V3.37143ZM11.8368 4.40918C11.4228 4.40918 11.0868 4.7448 11.0868 5.15893C11.0868 5.57299 11.4228 5.90893 11.8368 5.90893C12.2509 5.90893 12.5868 5.57299 12.5868 5.15893C12.5868 4.74487 12.2509 4.40893 11.8368 4.40893V4.40918ZM8.50056 5.28549C6.72806 5.28549 5.29094 6.72262 5.29094 8.49518C5.29094 10.2677 6.72806 11.7042 8.50056 11.7042C10.2731 11.7042 11.7098 10.2677 11.7098 8.49518C11.7098 6.72268 10.273 5.28549 8.50044 5.28549H8.50056ZM8.50056 6.4118C9.65112 6.4118 10.5839 7.34449 10.5839 8.49518C10.5839 9.64574 9.65112 10.5786 8.50056 10.5786C7.35 10.5786 6.41725 9.64574 6.41725 8.49518C6.41725 7.34449 7.34994 6.4118 8.50056 6.4118Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_861_786"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.75 17.7274) rotate(-90) scale(15.8572 14.7484)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_861_786"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-2.18006 1.64768) rotate(78.681) scale(7.08825 29.218)"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_861_786">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5 0.495117)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
